module.exports = __webpack_public_path__ + "img/down-chevron.f000e968.png";